/* eslint-disable react/display-name */
/* eslint-disable camelcase */
/* eslint-disable comma-dangle */

import React from 'react';
import dynamic from 'next/dynamic';
import Highlight from 'react-scale/components/ui/highlight';
import ExampleLoading from '../ExampleLoading';

const TaskResponseAnnotation = dynamic(() => import('../tasks/TaskResponseImageBoundingBox'), {
  loading: () => <ExampleLoading />,
  ssr: false
});

export const realResponse = {
  annotations: [
    {
      width: 117,
      height: 94,
      left: 0,
      top: 51,
      label: 'rooftop'
    },
    {
      width: 74,
      height: 17,
      left: 23,
      top: 0,
      label: 'rooftop'
    },
    {
      width: 50,
      height: 46,
      left: 139,
      top: 2,
      label: 'pool'
    },
    {
      width: 39,
      height: 50,
      left: 223,
      top: 0,
      label: 'pool'
    },
    {
      width: 82,
      height: 23,
      left: 297,
      top: 0,
      label: 'rooftop'
    },
    {
      width: 58,
      height: 54,
      left: 144,
      top: 102,
      label: 'pool'
    },
    {
      width: 107,
      height: 101,
      left: 279,
      top: 46,
      label: 'rooftop'
    },
    {
      width: 46,
      height: 62,
      left: 225,
      top: 78,
      label: 'pool'
    },
    {
      width: 34,
      height: 38,
      left: 258,
      top: 123,
      label: 'rooftop'
    },
    {
      width: 112,
      height: 101,
      left: 10,
      top: 169,
      label: 'rooftop'
    },
    {
      width: 45,
      height: 43,
      left: 151,
      top: 202,
      label: 'pool'
    },
    {
      width: 55,
      height: 67,
      left: 226,
      top: 179,
      label: 'pool'
    },
    {
      width: 87,
      height: 97,
      left: 292,
      top: 168,
      label: 'rooftop'
    },
    {
      width: 90,
      height: 105,
      left: 10,
      top: 281,
      label: 'rooftop'
    },
    {
      width: 51,
      height: 66,
      left: 158,
      top: 313,
      label: 'pool'
    },
    {
      width: 40,
      height: 60,
      left: 229,
      top: 290,
      label: 'pool'
    },
    {
      width: 89,
      height: 87,
      left: 294,
      top: 286,
      label: 'rooftop'
    },
    {
      width: 99,
      height: 105,
      left: 0,
      top: 402,
      label: 'rooftop'
    },
    {
      width: 51,
      height: 72,
      left: 161,
      top: 408,
      label: 'pool'
    },
    {
      width: 53,
      height: 61,
      left: 228,
      top: 426,
      label: 'pool'
    },
    {
      width: 86,
      height: 95,
      left: 298,
      top: 414,
      label: 'rooftop'
    },
    {
      width: 96,
      height: 94,
      left: 3,
      top: 535,
      label: 'rooftop'
    },
    {
      width: 39,
      height: 53,
      left: 101,
      top: 560,
      label: 'rooftop'
    },
    {
      width: 34,
      height: 33,
      left: 177,
      top: 506,
      label: 'rooftop'
    },
    {
      width: 41,
      height: 62,
      left: 167,
      top: 536,
      label: 'pool'
    },
    {
      width: 38,
      height: 32,
      left: 257,
      top: 506,
      label: 'rooftop'
    },
    {
      width: 55,
      height: 63,
      left: 230,
      top: 536,
      label: 'pool'
    },
    {
      width: 92,
      height: 106,
      left: 299,
      top: 517,
      label: 'rooftop'
    },
    {
      width: 103,
      height: 30,
      left: 565,
      top: 0,
      label: 'rooftop'
    },
    {
      width: 79,
      height: 12,
      left: 856,
      top: 0,
      label: 'rooftop'
    },
    {
      width: 98,
      height: 87,
      left: 565,
      top: 51,
      label: 'rooftop'
    },
    {
      width: 44,
      height: 42,
      left: 756,
      top: 58,
      label: 'pool'
    },
    {
      width: 95,
      height: 106,
      left: 847,
      top: 39,
      label: 'rooftop'
    },
    {
      width: 115,
      height: 90,
      left: 564,
      top: 182,
      label: 'rooftop'
    },
    {
      width: 42,
      height: 42,
      left: 688,
      top: 169,
      label: 'pool'
    },
    {
      width: 95,
      height: 90,
      left: 852,
      top: 169,
      label: 'rooftop'
    },
    {
      width: 102,
      height: 94,
      left: 566,
      top: 289,
      label: 'rooftop'
    },
    {
      width: 52,
      height: 54,
      left: 675,
      top: 320,
      label: 'pool'
    },
    {
      width: 35,
      height: 70,
      left: 768,
      top: 299,
      label: 'pool'
    },
    {
      width: 96,
      height: 94,
      left: 849,
      top: 286,
      label: 'rooftop'
    },
    {
      width: 99,
      height: 94,
      left: 568,
      top: 407,
      label: 'rooftop'
    },
    {
      width: 38,
      height: 59,
      left: 689,
      top: 417,
      label: 'pool'
    },
    {
      width: 36,
      height: 62,
      left: 747,
      top: 421,
      label: 'pool'
    },
    {
      width: 95,
      height: 90,
      left: 836,
      top: 408,
      label: 'rooftop'
    },
    {
      width: 94,
      height: 96,
      left: 566,
      top: 514,
      label: 'rooftop'
    },
    {
      width: 36,
      height: 71,
      left: 690,
      top: 514,
      label: 'pool'
    },
    {
      width: 106,
      height: 103,
      left: 842,
      top: 514,
      label: 'rooftop'
    }
  ]
};

export const instruction = 'Draw a box around each rooftop and pool.';

export const responseCode = `{
  "response": {
    "annotations": [
      {
        "width": 117,
        "height": 94,
        "left": 0,
        "top": 51,
        "label": "rooftop"
      },
      {
        "width": 74,
        "height": 17,
        "left": 23,
        "top": 0,
        "label": "rooftop"
      },
      ...
    ]
  },
  "task_id": "5795c68afce306120434be64",
  "task": { ... }
}`;

export const code = `client = launch.LaunchClient()
model_endpoint = client.create_endpoint (
  model_bundle=my_pytorch_model,
  **service_params
)

predictions = client.predict (
  model_endpoint, 
  image
)`;

export const response = (
  <div className="data-collection">
    <Highlight className="javascript" key="highlight-json">
      {responseCode}
    </Highlight>
  </div>
);

export const example = () => (
  <TaskResponseAnnotation annotations={[]} imageURL="/static/img/examples/2d-boxes-drones.png" />
);

export const result = (
  <TaskResponseAnnotation
    annotations={realResponse.annotations}
    imageURL="/static/img/examples/2d-boxes-drones.png"
  />
);
